import React from 'react';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../store/hooks';
import {Helmet} from 'react-helmet';
import {
  Container,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@mui/material';
import {Roles} from '../enums';
import PageTitle from './shared/PageTitle';
import FetchMembershipProDestination from './Admin/FetchMembershipProDestination';
import ResendShopifyMembershipKey from './Admin/ResendShopifyMembershipKey';
import {Link} from 'react-router-dom';
import TocIcon from '@mui/icons-material/Toc';

interface Props {}

const Admin: React.FC<Props> = () => {
  const {t} = useTranslation();
  const role = useAppSelector(state => state.profile.profile?.role);

  return (
    <>
      <Helmet>
        <title>{t('navigation.pageTitle', {pageName: t('pages.admin')})}</title>
      </Helmet>
      <Container>
        {role === Roles.admin && (
          <>
            <PageTitle>{t('pages.admin')}</PageTitle>
            <Paper sx={{mb: 2}}>
              <List>
                <ListItemButton component={Link} to="/admin/organizations">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.organizations')} />
                </ListItemButton>
                <ListItemButton component={Link} to="/admin/teams">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.teams')} />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/profile-delete-requests">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.profileDeleteRequests')} />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/pending-shopify-subscription-returns">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t('pages.pendingShopifySubscriptionReturn')}
                  />
                </ListItemButton>
                <ListItemButton component={Link} to="/admin/devices">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.devices')} />
                </ListItemButton>
                <ListItemButton component={Link} to="/admin/venues">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.venues')} />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/shopify-subscriptions">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.shopifySubscriptions')} />
                </ListItemButton>
                <ListItemButton component={Link} to="/admin/profiles">
                  <ListItemIcon>
                    <TocIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('pages.profiles')} />
                </ListItemButton>
              </List>
            </Paper>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} md={6}>
                <UnpairTeamDevices />
              </Grid> */}
              <Grid item xs={12} md={6}>
                <FetchMembershipProDestination />
              </Grid>
              <Grid item xs={12} md={6}>
                <ResendShopifyMembershipKey />
              </Grid>
            </Grid>
          </>
        )}
        {role !== Roles.admin && (
          <>
            <PageTitle>{t('general.forbidden')}</PageTitle>
          </>
        )}
      </Container>
    </>
  );
};

export default Admin;
